import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../app/Api/ApiSlice';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';
import './pages.css';
import ProductCard from '../components/ProductCard';
import UserPostCard from "../components/UserPostCard";
import OrgPostCard from "../components/OrgPostCard";
import StoreFeedCard from '../components/StoreFeedCard';
import { FaSearch } from 'react-icons/fa';
import OrgCard from '../components/OrgCard';
import UserCard from '../components/UserCard';

const Search = () => {
    const [searchedTerm, setSearchedTerm] = useState('');
    const [searchedType, setSearchedType] = useState('');
    const [searchResults, setSearchResults] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    const handleSearch = async (e, type = searchedType) => {
        if (e) e.preventDefault();

        if (!searchedTerm.trim()) {
            toast.warn('Please enter a search term.');
            return;
        }

        try {
            setIsLoading(true);

            const response = await api.get('/search', {
                params: {
                    search: searchedTerm,
                    searchType: type || undefined,
                },
            });

            console.log(response)

            setSearchResults(response.data);
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Search failed.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSeeMore = (type) => {
        setSearchedType(type);
        handleSearch(null, type);
    };

    return (
        <div className="page">
            <div className="page-body">
                <form className="search-form" onSubmit={handleSearch}>
                    <div className="search-page-form">
                        <input
                            type="search"
                            placeholder="Input your search"
                            value={searchedTerm}
                            onChange={(e) => setSearchedTerm(e.target.value)}
                        />
                        <button type="submit">
                            <FaSearch />
                        </button>
                    </div>
                </form>

                {isLoading && <Loader />}

                <div className="search-results">

                    {searchResults.posts?.length > 0 && (
                        <div className="posts-search-results">
                            <p className="search-title">Posts</p>
                            {searchResults.posts.map((post) => (
                                <OrgPostCard orgPost={post} />
                            ))}
                            <div className="search-seemore-btn">
                                <button onClick={() => handleSeeMore('posts')}>
                                    See more
                                </button>
                            </div>
                        </div>
                    )}

                    {searchResults.users?.length > 0 && (
                        <div className="posts-search-results">
                            <p className="search-title">People</p>
                            {searchResults.users.map((usr) => (
                                <UserCard user={usr} />
                            ))}
                            <div className="search-seemore-btn">
                                <button onClick={() => handleSeeMore('users')}>
                                    See more
                                </button>
                            </div>
                        </div>
                    )}
                    {searchResults.organizations?.length > 0 && (
                        <div className="posts-search-results">
                            <p className="search-title">Organizations</p>
                            {searchResults.organizations.map((org) => (
                                <OrgCard org={org} />
                            ))}
                            <div className="search-seemore-btn">
                                <button onClick={() => handleSeeMore('organizations')}>
                                    See more
                                </button>
                            </div>
                        </div>
                    )}
                    {searchResults.stores?.length > 0 && (
                        <div className="posts-search-results">
                            <p className="search-title">Businesses</p>
                            {searchResults.stores.map((str) => (
                                <StoreFeedCard str={str} />
                            ))}
                            <div className="search-seemore-btn">
                                <button onClick={() => handleSeeMore('stores')}>
                                    See more
                                </button>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default Search;
